import React, {useState, useEffect, useRef, useMemo} from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import countryOptions from "../../../components/List/Countries";
import { Checkbox, FormControlLabel, IconButton } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Button from "@mui/material/Button";
import {Link, useLocation, useNavigate} from "react-router-dom";
import CrudService from "services/cruds-service";
import {LocalizationProvider, DatePicker} from "@mui/x-date-pickers";
import "jspdf-autotable";
import Switch from "@mui/material/Switch";
import { tr } from "date-fns/locale";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DataTable from "../../../../../../../examples/Tables/DataTable";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InputAdornment from "@mui/material/InputAdornment";
import { AddRowButton, RemoveRowButton } from "components/RowActions";
import { CrmPageHeader, CrmNotice, crmCardSx } from "../../shared/CrmUi";

const RoadForm = ({ selectedTransportType }) => {
    const initialAddressStatePickup = {
        additionalInfo: "",
        selectedPickupCountry:"",
        pickupCity:""
    };
    const initialAddressStateDelivery = {
        additionalInfo: "",
        selectedDeliveryCountry:"",
        deliveryCity:""
    };

    const statusOptions = [
        { label: "Prospect" },
        { label: "Needs Assessment" },
        { label: "Target" },
        { label: "Secured" },
        { label: "Lost" },
    ];

    const frequencyOptions = [
        { label: "Weekly" },
        { label: "Monthly" },
        { label: "Yearly" },
    ];

    const containerOptions = [
        { label: "20'DC" }, // Standart Kamyon
        { label: "40'HC" }, // Soğutuculu Kamyon
    ];

    const truckType = [
        { label: "Standard Truck" }, // Standart Kamyon
        { label: "Refrigerated Truck" }, // Soğutuculu Kamyon
        { label: "Container Truck" }, // Konteyner Taşıyan Kamyon
        { label: "Flatbed Truck" }, // Açık Kasa Kamyon
        { label: "Tanker Truck" }, // Tanker Kamyon
        { label: "Lowboy Truck" }, // Düşük Yükleme Kasalı Kamyon
        { label: "Dump Truck" }, // Damperli Kamyon
        { label: "Car Carrier Truck" }, // Araç Taşıyıcı Kamyon
        { label: "Tow Truck" }, // Çekici Kamyon
        { label: "Fire Truck" } // İtfaiye Kamyonu
    ];

    const paymentPerformanceOptions = [
        { label: "On-Time" },
        { label: "Delayed" },
        { label: "Risky" },
    ];

    const priceComparisonOptions = [
        { label: "Higher" },
        { label: "Lower" },
        { label: "Similar" },
        { label: "Avarage" },
    ];

    const loyaltyOptions = [
        { label: "1" },
        { label: "2" },
        { label: "3" },
        { label: "4" },
        { label: "5" },
    ];

    const customerCategoryOptions = [
        { label: "Existing Customer" },
        { label: "New Customer" },
        { label: "Potential Customer" },
        { label: "Global Agent" }
    ];
    const forwarderOptions = [
        { label: "Freight Forwarder" },
        { label: "Logistics Company (Asset Based)" },
    ];
    const statusMap = {
        Prospect:           { barValue: 20,  labelValue: 20,  color: "#FFB300" },
        "Needs Assessment": { barValue: 50,  labelValue: 50,  color: "#8E24AA" },
        Target:             { barValue: 70,  labelValue: 70,  color: "#053b97" },
        Secured:            { barValue: 100, labelValue: 100, color: "#4CAF50" },
        Lost:               { barValue: 5,   labelValue: 0,   color: "#F44336" }, // özel kural
    };

    const StatusDot = ({ status, size = 10 }) => (
        <span
            style={{
                width: size,
                height: size,
                borderRadius: 999,
                display: "inline-block",
                marginRight: 8,
                backgroundColor: statusMap[status]?.color || "#999",
                flexShrink: 0,
            }}
        />
    );


    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map(user => ({
                    id: user.id,
                    label: user.attributes.name
                }));

                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        };

        fetchSalesReps();
    }, []);

    function ProgressBar({ barValue, color }) {
        return (
            <Box
                sx={{
                    width: "100%",
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "#ECEFF1",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        width: `${barValue}%`,
                        height: "100%",
                        backgroundColor: color,
                        transition: "width 300ms ease",
                    }}
                />
            </Box>
        );
    }
    const location = useLocation();
    const navigate = useNavigate();
    const isFromMeetings = location.state?.fromMeetings || false;
    const [customerOptions, setCustomerOptions] = useState([]);
    const [opportunityData, setOpportunityData] = useState(null);

    useEffect(() => {
        const st = location.state;
        if (!st?.fromLead) return;

        // 1) Customer
        if (st.customer) {
            // customerOptions varsa eşleştirmek daha doğru
            const match = customerOptions.find(x => x.id === st.customer.id) || st.customer;
            setSelectedCustomer(match);
            setShowButtons(false);
            setCustomerType("existing");
        }

        // 2) Origin -> Pickup
        if (st.origin?.country) {
            const c = countryOptions.find(opt => opt.label === st.origin.country) || null;
            setSelectedPickupCountry(c);
            setPickupLocation(p => ({
                ...p,
                selectedPickupCountry: c ? c.label : st.origin.country,
                pickupCity: st.origin?.port || p.pickupCity,
            }));
        } else if (st.origin?.port) {
            setPickupLocation(p => ({ ...p, pickupCity: st.origin.port }));
        }

        // 3) Destination -> Delivery
        if (st.destination?.country) {
            const c = countryOptions.find(opt => opt.label === st.destination.country) || null;
            setSelectedDeliveryCountry(c);
            setDeliveryLocation(p => ({
                ...p,
                selectedDeliveryCountry: c ? c.label : st.destination.country,
                deliveryCity: st.destination?.port || p.deliveryCity,
            }));
        } else if (st.destination?.port) {
            setDeliveryLocation(p => ({ ...p, deliveryCity: st.destination.port }));
        }

    }, [location.state, customerOptions]);


    useEffect(() => {
        const st = location.state;
        if (!st?.fromLead) return;
        if (!salesRepOptions?.length) return;

        const ids = Array.isArray(st.salesRepIds) ? st.salesRepIds : (st.salesRepIds ? [st.salesRepIds] : []);
        const mapped = salesRepOptions.filter(u => ids.includes(u.id));

        setSalesRep(mapped);
    }, [location.state, salesRepOptions]);




    useEffect(() => {
        const fetchCustomersAndGlobalAgents = async () => {
            try {
                const [customerResponse, globalAgentResponse] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents()
                ]);

                const customerList = customerResponse.data.map((customer) => ({
                    name: customer.attributes?.name || "Unnamed Customer",
                    id: customer.id,
                    email: customer.attributes?.email || "customer@example.com",
                    type: "Customer",
                }));

                const globalAgentList = globalAgentResponse.data.map((agent) => ({
                    name: agent.attributes?.name || "Unnamed Global Agent",
                    id: agent.id,
                    email: agent.attributes?.email || "globalAgent@example.com",
                    type: "GlobalAgent",
                }));

                const combinedOptions = [...customerList, ...globalAgentList];

                setCustomerOptions(combinedOptions);

            } catch (error) {
                console.error("Müşteri ve Global Agent verileri alınırken hata:", error);
            }
        };
        fetchCustomersAndGlobalAgents();
    }, []);

    const [formData, setFormData] = useState({
        roadTransportType: "",
        customer: "",
        opportunityName: "",
        salesRep: "",
        salesTeam:"",
        pickupLocation: "",
        deliveryLocation: "",
        pickupDate: null,
        estimatedStartDate: null,
        estimatedEndDate: null,
        estimatedCloseDate: null,
        frequency: "",
        status: "",
        lostReason: "",
        originFreeTime: "",
        description: "",
        selectedTransportType: selectedTransportType || "",
        selectedCountry: "",
        truckType: "",
        avgMonthlyShipment: 0,
        freightRate: 0,
        avgCBM: 0,
        container: "",
        freightRateCurrency: "",
        totalRevenue: 0,
        grossProfitType: "",
        perTruckProfit: "",
        perTruckGrossProfit: 0,
        percentageProfit: "",
        percentageGrossProfit: 0,
        pricePer20DC: "",
        pricePer40HC: "",
        container20DC: "",
        container40HC: "",
        totalRevenueSum: 0,
        totalPerTruckProfitSum: 0,
        totalPercentageGrossProfitSum: 0,
        domesticBlocks: [
            {
                selectedContainer: null,
                avgMonthlyShipment: "",
                freightRate: "",
                currency: "EUR",
                totalRevenue: 0,
                grossProfitType: "",
                perTruckProfit: "",
                perTruckGrossProfit: 0,
                percentageProfit: "",
                percentageGrossProfit: 0,
            },
        ],
        paymentTerms:"",
        paymentPerformance:"",
        operationalChallenges:"",
        competingFreightForwarders:"",
        competingTransportCompanies:"",
        priceComparison:"",
        loyalty:"",
        customerCategory:"",
        lastFollowupDate: null,
        nextFollowupDate: null,
        lastMeetingDate: null,
        nextMeetingDate: null,
        forwarder:"",
        grossProfitRate:"",
        estimatedBuyingRates:""
    });
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            selectedTransportType: selectedTransportType,
        }));
    }, [selectedTransportType]);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const opportunityId = searchParams.get("id");
    const [successMessage, setSuccessMessage] = useState("");
    const successMessageRef = useRef(null);
    useEffect(() => {
        if (opportunityId) {
            setIsEditing(true);
            fetchOpportunityDetails(opportunityId);
        }
    }, [opportunityId]);

    const fetchOpportunityDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getOpportunityById(id);
            const opportunityData = response.data.attributes;
            const matchedCustomer = customerOptions.find(
                (opt) =>
                    opt.name?.trim().toLowerCase() ===
                    opportunityData.customer?.trim().toLowerCase()
            );
            setOpportunityData(opportunityData);
            setSelectedCustomer(matchedCustomer || null);
            setSalesRep(
                Array.isArray(opportunityData.salesRep)
                    ? salesRepOptions.filter(repOption =>
                        opportunityData.salesRep.includes(repOption.id)
                    )
                    : []
            );
            setSalesTeam(
                Array.isArray(opportunityData.salesTeam)
                    ? salesRepOptions.filter(repOption =>
                        opportunityData.salesTeam.includes(repOption.id)
                    )
                    : []
            );
            setRoadTransportType(opportunityData.roadTransportType || "");
            setSelectedStatus(opportunityData.status || "");
            setOpportunityName(opportunityData.opportunityName || "");
            setPickupLocation({
                additionalInfo: opportunityData.pickupLocation?.additionalInfo || "",
                pickupCity: opportunityData.pickupLocation?.pickupCity || "",
                selectedPickupCountry: opportunityData.pickupLocation?.selectedPickupCountry || "",
            });
            setSelectedPickupCountry(
                countryOptions.find(opt => opt.label === opportunityData.pickupLocation?.selectedPickupCountry) || null
            );
            setDeliveryLocation({
                additionalInfo: opportunityData.deliveryLocation?.additionalInfo || "",
                deliveryCity: opportunityData.deliveryLocation?.deliveryCity || "",
                selectedDeliveryCountry: opportunityData.deliveryLocation?.selectedDeliveryCountry || "",
            });
            setSelectedDeliveryCountry(
                countryOptions.find(opt => opt.label === opportunityData.deliveryLocation?.selectedDeliveryCountry) || null
            );
            setEstimatedCloseDate(opportunityData.estimatedCloseDate ? new Date(opportunityData.estimatedCloseDate) : null);
            setEstimatedStartDate(opportunityData.estimatedStartDate ? new Date(opportunityData.estimatedStartDate) : null);
            setEstimatedEndDate(opportunityData.estimatedEndDate ? new Date(opportunityData.estimatedEndDate) : null);
            setLastFollowupDate(opportunityData.lastFollowupDate ? new Date(opportunityData.lastFollowupDate) : null);
            setNextFollowupDate(opportunityData.nextFollowupDate ? new Date(opportunityData.nextFollowupDate) : null);
            setLastMeetingDate(opportunityData.lastMeetingDate ? new Date(opportunityData.lastMeetingDate) : null);
            setNextMeetingDate(opportunityData.nextMeetingDate ? new Date(opportunityData.nextMeetingDate) : null);
            setSelectedFrequency(opportunityData.frequency || "");
            setLostReason(opportunityData.lostReason || "");
            setAvgMonthlyShipment(opportunityData.avgMonthlyShipment || "");
            setFreightRate(opportunityData.freightRate || "");
            setAvgCBM(opportunityData.avgCBM || "");
            setDescription(opportunityData.description || "");
            setSelectedTransportType(opportunityData.selectedTransportType || "");
            setSelectedTransport(truckType.find(opt => opt.label.toLowerCase() === opportunityData.truckType?.toLowerCase()) || null);
            setSelectedContainers(containerOptions.find(opt => opt.label.toLowerCase() === opportunityData.containers?.toLowerCase()) || null);
            setFreightRateCurrency(opportunityData.freightRateCurrency || "");
            setTotalRevenue(opportunityData.totalRevenue || 0);
            setGrossProfitType(opportunityData.grossProfitType || "");
            setPerTruckProfit(opportunityData.perTruckProfit !== "" ? opportunityData.perTruckProfit : "");
            setPercentageProfit(opportunityData.percentageProfit !== "" ? opportunityData.percentageProfit : "");
            setPerTruckGrossProfit((parseFloat(perTruckProfit) || 0) * (parseFloat(avgMonthlyShipment) || 0));
            setPercentageGrossProfit(totalRevenue * ((parseFloat(percentageProfit) / 100) || 1));
            setPricePer20DC(opportunityData.pricePer20DC || "");
            setPricePer40HC(opportunityData.pricePer40HC || "");
            setContainer20DC(opportunityData.container20DC || "");
            setContainer40HC(opportunityData.container40HC || "");
            setTotalRevenueSum(opportunityData.totalRevenueSum || 0);
            setTotalPerTruckProfitSum(opportunityData.totalPerTruckProfitSum || 0);
            setTotalPercentageGrossProfitSum(opportunityData.totalPercentageGrossProfitSum || 0);
            setDomesticBlocks(opportunityData.domesticBlocks || []);
            setPaymentTerms(opportunityData.paymentTerms || "");
            setSelectedPaymentPerformance(opportunityData.paymentPerformance || "");
            setOperationalChallenges(opportunityData.operationalChallenges || "");
            setCompetingFreightForwarders(opportunityData.competingFreightForwarders || "");
            setCompetingTransportCompanies(opportunityData.competingTransportCompanies || "");
            setSelectedPriceComparison(opportunityData.priceComparison || "");
            setSelectedLoyalty(opportunityData.loyalty || "");
            setSelectedCustomerCategory(opportunityData.customerCategory || "");
            setSelectedForwarder(opportunityData.forwarder || "");
            setEstimatedBuyingRates(opportunityData.estimatedBuyingRates || "");
            setGrossProfitRate(opportunityData.grossProfitRate || "");
            setSelectedStrategies(opportunityData.strategies || []);
            setSelectedKeyMarkets(opportunityData.selectedKeyMarkets || {});
            setFormData({
                roadTransportType: opportunityData.roadTransportType || "",
                customer: matchedCustomer?.name || "Unknown Customer",
                opportunityName: opportunityData.opportunityName || "",
                salesRep: opportunityData.salesRep || "",
                salesTeam: opportunityData.salesTeam || "",
                quoteNo: opportunityData.quoteNo || "",
                description: opportunityData.description || "",
                originFreeTime: opportunityData.originFreeTime || "",
                pickupLocation: opportunityData.pickupLocation || {},
                deliveryLocation: opportunityData.deliveryLocation || {},
                estimatedCloseDate: opportunityData.estimatedCloseDate || null,
                estimatedStartDate: opportunityData.estimatedStartDate || null,
                estimatedEndDate: opportunityData.estimatedEndDate || null,
                lastFollowupDate: opportunityData.lastFollowupDate || null,
                nextFollowupDate: opportunityData.nextFollowupDate || null,
                lastMeetingDate: opportunityData.lastMeetingDate || null,
                nextMeetingDate: opportunityData.nextMeetingDate || null,
                selectedTransportType: opportunityData.selectedTransportType || "",
                frequency: opportunityData.frequency || "",
                lostReason: opportunityData.lostReason || "",
                avgMonthlyShipment: opportunityData.avgMonthlyShipment || "",
                freightRate: opportunityData.freightRate || "",
                avgCBM: opportunityData.avgCBM || "",
                truckType: opportunityData.truckType || "",
                containers: opportunityData.containers || "",
                freightRateCurrency: opportunityData.freightRateCurrency || "",
                totalRevenue: opportunityData.totalRevenue || "",
                grossProfitType: opportunityData.grossProfitType || "",
                perTruckProfit: opportunityData.perTruckProfit || "",
                perTruckGrossProfit: opportunityData.perTruckGrossProfit || 0,
                percentageProfit: opportunityData.percentageProfit || "",
                percentageGrossProfit: opportunityData.percentageGrossProfit || 0,
                pricePer20DC: opportunityData.pricePer20DC || "",
                pricePer40HC: opportunityData.pricePer40HC || "",
                container20DC: opportunityData.container20DC || "",
                container40HC: opportunityData.container40HC || "",
                totalRevenueSum: opportunityData.totalRevenueSum || 0,
                totalPerTruckProfitSum: opportunityData.totalPerTruckProfitSum || 0,
                totalPercentageGrossProfitSum: opportunityData.totalPercentageGrossProfitSum || 0,
                domesticBlocks: opportunityData.domesticBlocks || [],
                paymentTerms: opportunityData.paymentTerms || "",
                paymentPerformance: opportunityData.paymentPerformance || "",
                operationalChallenges: opportunityData.operationalChallenges || "",
                competingFreightForwarders: opportunityData.competingFreightForwarders || "",
                competingTransportCompanies: opportunityData.competingTransportCompanies || "",
                priceComparison: opportunityData.priceComparison || "",
                loyalty: opportunityData.loyalty || "",
                customerCategory: opportunityData.customerCategory || "",
                forwarder: opportunityData.forwarder || "",
                grossProfitRate: opportunityData.grossProfitRate || "",
                estimatedBuyingRates: opportunityData.estimatedBuyingRates || "",
            });
        } catch (error) {
            console.error("Error fetching Opportunity details:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (customerOptions.length > 0) {
            fetchOpportunityDetails(opportunityId);
        }
    }, [customerOptions, opportunityId]);
    const [pickupLocation, setPickupLocation] = useState(initialAddressStatePickup);
    const [deliveryLocation, setDeliveryLocation] = useState(initialAddressStateDelivery);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [salesRep, setSalesRep] = useState([]);
    const [salesTeam, setSalesTeam] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("Prospect");
    const { barValue, labelValue, color } = statusMap[selectedStatus] || statusMap.Lost;
    const [opportunityName, setOpportunityName] = useState("");
    const [estimatedCloseDate, setEstimatedCloseDate] = useState(null);
    const [estimatedStartDate, setEstimatedStartDate] = useState(null);
    const [estimatedEndDate, setEstimatedEndDate] = useState(null);
    const [lastFollowupDate, setLastFollowupDate] = useState(null);
    const [nextFollowupDate, setNextFollowupDate] = useState(null);
    const [lastMeetingDate, setLastMeetingDate] = useState(null);
    const [nextMeetingDate, setNextMeetingDate] = useState(null);
    const [selectedFrequency, setSelectedFrequency] = useState("");
    const [lostReason, setLostReason] = useState("");
    const [avgMonthlyShipment, setAvgMonthlyShipment] = useState("");
    const [freightRate, setFreightRate] = useState("");
    const [avgCBM, setAvgCBM] = useState("");
    const [description, setDescription] = useState("");
    const [roadTransportType, setRoadTransportType] = useState("FTL");
    const [setSelectedTransportType] = useState("");
    const [selectedPickupCountry, setSelectedPickupCountry] = useState(null);
    const [selectedDeliveryCountry, setSelectedDeliveryCountry] = useState(null);
    const [selectedTransport, setSelectedTransport] = useState("");
    const [selectedContainers, setSelectedContainers] = useState("");
    const [freightRateCurrency, setFreightRateCurrency] = useState("");
    const [grossProfitType, setGrossProfitType] = useState("");
    const [perTruckProfit, setPerTruckProfit] = useState("");
    const [percentageProfit, setPercentageProfit] = useState("");
    const [percentageGrossProfit, setPercentageGrossProfit] = useState(0);
    const [perTruckGrossProfit, setPerTruckGrossProfit] = useState("");
    const [totalRevenue, setTotalRevenue] = useState("");
    const [pricePer20DC, setPricePer20DC] = useState("");
    const [pricePer40HC, setPricePer40HC] = useState("");
    const [container20DC, setContainer20DC] = useState("");
    const [container40HC, setContainer40HC] = useState("");
    const [totalRevenueSum, setTotalRevenueSum] = useState(0);
    const [totalPerTruckProfitSum, setTotalPerTruckProfitSum] = useState(0);
    const [totalPercentageGrossProfitSum, setTotalPercentageGrossProfitSum] = useState(0);
    const [domesticBlocks, setDomesticBlocks] = useState([]);
    const [paymentTerms, setPaymentTerms] = useState("");
    const [selectedPaymentPerformance, setSelectedPaymentPerformance] = useState("");
    const [operationalChallenges, setOperationalChallenges] = useState("");
    const [competingFreightForwarders, setCompetingFreightForwarders] = useState("");
    const [competingTransportCompanies, setCompetingTransportCompanies] = useState("");
    const [selectedPriceComparison, setSelectedPriceComparison] = useState("");
    const [selectedLoyalty, setSelectedLoyalty] = useState("");
    const [selectedCustomerCategory, setSelectedCustomerCategory] = useState("");
    const [selectedForwarder, setSelectedForwarder] = useState("");
    const [estimatedBuyingRates, setEstimatedBuyingRates] = useState("");
    const [grossProfitRate, setGrossProfitRate] = useState("");
    const [competitorsList, setCompetitorsList] = useState([]);
    const [showButtons, setShowButtons] = useState(!selectedCustomer);
    const [customerType, setCustomerType] = useState(selectedCustomer ? selectedCustomer.type : null);
    // --- city option states
    const [pickupCityOptions, setPickupCityOptions] = useState([]);
    const [deliveryCityOptions, setDeliveryCityOptions] = useState([]);
    const [pickupCityLoading, setPickupCityLoading] = useState(false);
    const [deliveryCityLoading, setDeliveryCityLoading] = useState(false);

// ülke -> şehirler cache
    const citiesCacheRef = useRef(new Map());

    const normalizeCities = (resp) => {
        const raw = resp?.data?.data ?? resp?.data ?? [];
        // string[] veya { name }[] veya { label }[] destekler
        return raw
            .map((x) => (typeof x === "string" ? x : x?.name || x?.label || x?.city))
            .filter(Boolean)
            .map((name) => ({ label: name, value: name }));
    };

    const fetchCities = async (countryLabel) => {
        if (!countryLabel) return [];

        if (citiesCacheRef.current.has(countryLabel)) {
            return citiesCacheRef.current.get(countryLabel);
        }

        const resp = await CrudService.getCitiesByCountry(countryLabel);
        const cities = normalizeCities(resp);

        citiesCacheRef.current.set(countryLabel, cities);
        return cities;
    };

    useEffect(() => {
        let alive = true;

        const run = async () => {
            const country = selectedPickupCountry?.label;
            if (!country) {
                setPickupCityOptions([]);
                setPickupLocation((p) => ({ ...p, pickupCity: "" }));
                return;
            }

            setPickupCityLoading(true);
            try {
                const cities = await fetchCities(country);
                if (!alive) return;
                setPickupCityOptions(cities);
            } finally {
                if (alive) setPickupCityLoading(false);
            }
        };

        run();
        return () => { alive = false; };
    }, [selectedPickupCountry]);

    useEffect(() => {
        let alive = true;

        const run = async () => {
            const country = selectedDeliveryCountry?.label;
            if (!country) {
                setDeliveryCityOptions([]);
                setDeliveryLocation((p) => ({ ...p, deliveryCity: "" }));
                return;
            }

            setDeliveryCityLoading(true);
            try {
                const cities = await fetchCities(country);
                if (!alive) return;
                setDeliveryCityOptions(cities);

                setDeliveryLocation((p) => {
                    const exists = cities.some((c) => c.value === p.deliveryCity);
                    return exists ? p : { ...p, deliveryCity: "" };
                });
            } finally {
                if (alive) setDeliveryCityLoading(false);
            }
        };

        run();
        return () => { alive = false; };
    }, [selectedDeliveryCountry]);



    const handleStateChange = (setter, key, value) => {
        setter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };
    useEffect(() => {
        if (location.state) {
            if (location.state.customer) {
                setSelectedCustomer({ name: location.state.customer });
            }
            if (location.state.meetingDate) {
                const parsedDate = new Date(location.state.meetingDate);
                if (!isNaN(parsedDate.getTime())) {
                    setLastMeetingDate(parsedDate);
                }
            }
        }
    }, [location.state]);
    const submitHandler = async (e) => {
        e.preventDefault();

        const opportunityData = {
            roadTransportType,
            customer: selectedCustomer?.name || "Unknown Customer",
            opportunityName,
            salesRep: salesRep.map(rep => rep.id),
            salesTeam: salesTeam.map(rep => rep.id),
            pickupLocation: {
                ...pickupLocation,
                selectedPickupCountry: selectedPickupCountry ? selectedPickupCountry.label : ""
            },
            deliveryLocation: {
                ...deliveryLocation,
                selectedDeliveryCountry: selectedDeliveryCountry ? selectedDeliveryCountry.label : ""
            },
            strategies: selectedStrategies,
            selectedKeyMarkets,
            estimatedCloseDate,
            estimatedStartDate,
            estimatedEndDate,
            lastFollowupDate,
            nextFollowupDate,
            lastMeetingDate,
            nextMeetingDate,
            frequency: selectedFrequency,
            status: selectedStatus,
            lostReason,
            description,
            avgMonthlyShipment,
            freightRate,
            avgCBM,
            selectedTransportType,
            truckType: selectedTransport ? selectedTransport.label : "",
            containers: selectedContainers ? selectedContainers.label : "",
            freightRateCurrency,
            totalRevenue,
            grossProfitType,
            perTruckProfit: grossProfitType === "perTruck" ? perTruckProfit : null,
            perTruckGrossProfit: grossProfitType === "perTruck" ? perTruckGrossProfit : null,
            percentageProfit: grossProfitType === "percentage" ? percentageProfit : null,
            percentageGrossProfit: grossProfitType === "percentage" ? percentageGrossProfit : null,
            pricePer20DC,
            pricePer40HC,
            container20DC,
            container40HC,
            totalRevenueSum,
            totalPerTruckProfitSum,
            totalPercentageGrossProfitSum,
            domesticBlocks,
            paymentTerms,
            paymentPerformance: selectedPaymentPerformance,
            operationalChallenges,
            competingFreightForwarders,
            competingTransportCompanies,
            priceComparison: selectedPriceComparison,
            loyalty: selectedLoyalty,
            customerCategory: selectedCustomerCategory,
            forwarder: selectedForwarder,
            grossProfitRate,
            estimatedBuyingRates
        };
        try {
            setLoading(true);
            let response;
            if (isEditing) {
                response = await CrudService.updateOpportunity(opportunityData, opportunityId);
                setSuccessMessage("Update operation was successfully completed.");
            } else {
                response = await CrudService.createOpportunity({
                    data: opportunityData,
                });
                setSuccessMessage("Create operation was successfully completed.");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            setTimeout(() => {
                navigate("/opportunity/opportunity-tables/details");
            }, 3000);
        } catch (err) {
            console.error("Request failed: ", err);
        } finally {
            setLoading(false);
        }
    };
    const handleSwitchChangeTransportType = (type) => {
        setRoadTransportType((prevType) => (prevType === type ? "" : type));
    }
    const customerFromMeeting = searchParams.get("customer");
    useEffect(() => {
        if (customerFromMeeting) {
            setSelectedCustomer({ name: customerFromMeeting });
        }
    }, [customerFromMeeting]);

    useEffect(() => {
        if (opportunityData && truckType.length > 0 && containerOptions.length > 0) {
            setSelectedTransport(
                truckType.find(opt => opt.label.toLowerCase() === opportunityData.truckType?.toLowerCase()) || null
            );
            setSelectedContainers(
                containerOptions.find(opt => opt.label.toLowerCase() === opportunityData.container?.toLowerCase()) || null
            );
        }
    }, [opportunityData, truckType, containerOptions, isEditing]);

    useEffect(() => {
        const earnings = parseFloat(freightRate) || 0;
        const shipments = parseFloat(avgMonthlyShipment) || 0;
        let calculatedRevenue = 0;
        if (roadTransportType === "FTL" || roadTransportType === "Domestic") {
            calculatedRevenue = earnings * shipments;
        } else if (roadTransportType === "LTL") {
            calculatedRevenue = earnings * shipments;
        } else if (roadTransportType === "Domestic") {
            let container20DCCount = parseFloat(container20DC) || 0;
            let container40HCCount = parseFloat(container40HC) || 0;

            calculatedRevenue = (container20DCCount * pricePer20DC) + (container40HCCount * pricePer40HC);
        }

        setTotalRevenue(calculatedRevenue);
    }, [freightRate, avgMonthlyShipment, avgCBM, roadTransportType, container20DC, container40HC, pricePer20DC, pricePer40HC]);

    useEffect(() => {
        setPerTruckGrossProfit(parseFloat(perTruckProfit) * parseFloat(avgMonthlyShipment) || 0);
    }, [perTruckProfit, avgMonthlyShipment]);

    useEffect(() => {
        const revenue = parseFloat(totalRevenue) || 0;
        const profitPercentage = parseFloat(percentageProfit) || 1;
        setPercentageGrossProfit(revenue * (profitPercentage/100));
    }, [totalRevenue, percentageProfit]);

    useEffect(() => {
        if (opportunityData) {
            setFreightRate(opportunityData.freightRate || "");
            setFreightRateCurrency(opportunityData.freightRateCurrency || "");
            setTotalRevenue(opportunityData.totalRevenue || 0);
            setGrossProfitType(opportunityData.grossProfitType || "");
            setPerTruckProfit(opportunityData.perTruckProfit ?? "");
            setPerTruckGrossProfit(opportunityData.perTruckGrossProfit ?? "");
            setPercentageProfit(opportunityData.percentageProfit ?? "");
            setPercentageGrossProfit(opportunityData.percentageGrossProfit ?? "");
            setEstimatedBuyingRates(opportunityData.estimatedBuyingRates || "");
            setGrossProfitRate(opportunityData.grossProfitRate || "");
        }
    }, [opportunityData]);

    useEffect(() => {
        if (opportunityData && typeof opportunityData.containers === "string") {
            const matchedContainer = containerOptions.find(opt =>
                opt.label.toLowerCase() === opportunityData.containers.toLowerCase()
            );
            setSelectedContainers(matchedContainer || null);
        }
    }, [opportunityData, containerOptions]);

    useEffect(() => {
        setDomesticBlocks([
            {
                selectedContainer: null,
                avgMonthlyShipment: "",
                freightRate: "",
                currency: "EUR",
                totalRevenue: 0,
                grossProfitType: "",
                perTruckProfit: "",
                perTruckGrossProfit: 0,
                percentageProfit: "",
                percentageGrossProfit: 0,
                estimatedBuyingRates:0,
                grossProfitRate:0
            }
        ]);
    }, []);


    const updateDomesticBlock = (index, field, value) => {
        const updatedBlocks = [...domesticBlocks];
        updatedBlocks[index][field] = value;
        if (field === "freightRate" || field === "avgMonthlyShipment") {
            const earnings = parseFloat(updatedBlocks[index].freightRate) || 0;
            const shipments = parseFloat(updatedBlocks[index].avgMonthlyShipment) || 0;
            updatedBlocks[index].totalRevenue = earnings * shipments;
        }
        if (field === "perTruckProfit") {
            const profit = parseFloat(updatedBlocks[index].perTruckProfit) || 0;
            updatedBlocks[index].perTruckGrossProfit = profit * (parseFloat(updatedBlocks[index].avgMonthlyShipment) || 0);
        }
        if (field === "percentageProfit") {
            const revenue = parseFloat(updatedBlocks[index].totalRevenue) || 0;
            const profitPercentage = parseFloat(updatedBlocks[index].percentageProfit) || 0;
            updatedBlocks[index].percentageGrossProfit = revenue * (profitPercentage / 100);
        }
        setDomesticBlocks(updatedBlocks);
    };

    const removeDomesticBlock = (index) => {
        if (domesticBlocks.length > 1) {
            const updatedBlocks = [...domesticBlocks];
            updatedBlocks.splice(index, 1);
            setDomesticBlocks(updatedBlocks);
        }
    };
    useEffect(() => {
        let totalRevenue = 0;
        let totalPerTruckProfit = 0;
        let totalPercentageGrossProfit = 0;

        domesticBlocks.forEach(block => {
            totalRevenue += block.totalRevenue;
            totalPerTruckProfit += block.perTruckGrossProfit;
            totalPercentageGrossProfit += block.percentageGrossProfit;
        });

        setTotalRevenueSum(totalRevenue);
        setTotalPerTruckProfitSum(totalPerTruckProfit);
        setTotalPercentageGrossProfitSum(totalPercentageGrossProfit);
    }, [domesticBlocks]);
    const addNewDomesticBlock = () => {
        setDomesticBlocks(prevBlocks => [
            ...prevBlocks,
            { grossProfitType: prevBlocks[0]?.grossProfitType, currency: "" }
        ]);
    };

    useEffect(() => {
        if (opportunityData?.domesticBlocks && opportunityData.domesticBlocks.length > 0) {
            setDomesticBlocks(opportunityData.domesticBlocks);
        } else {
            setDomesticBlocks([
                {
                    selectedContainer: null,
                    avgMonthlyShipment: "",
                    freightRate: "",
                    currency: "EUR",
                    totalRevenue: 0,
                    grossProfitType: "",
                    perTruckProfit: "",
                    perTruckGrossProfit: 0,
                    percentageProfit: "",
                    percentageGrossProfit: 0,
                    estimatedBuyingRates:0,
                    grossProfitRate:0
                },
            ]);
        }
    }, [opportunityData]);

    useEffect(() => {
        if (opportunityData) {
            setPaymentTerms(opportunityData.paymentTerms || "");
            setSelectedPaymentPerformance(opportunityData.paymentPerformance || "");
            setOperationalChallenges(opportunityData.operationalChallenges || "");
            setCompetingFreightForwarders(opportunityData.competingFreightForwarders || "");
            setCompetingTransportCompanies(opportunityData.competingTransportCompanies || "");
            setSelectedPriceComparison(opportunityData.priceComparison || "");
            setSelectedLoyalty(opportunityData.loyalty || "");
            setSelectedCustomerCategory(opportunityData.customerCategory || "");
            setSelectedForwarder(opportunityData.forwarder || "");

        }
    }, [opportunityData]);

    const [avgMonthlyShipmentLabel, setAvgMonthlyShipmentLabel] = useState("Avg. Monthly LCL Shipments");

    useEffect(() => {
        if (selectedFrequency) {
            setAvgMonthlyShipmentLabel(`Avg. ${selectedFrequency} LCL Shipments`);
        }
    }, [selectedFrequency]);

    const [avgMonthlyShipmentLabelDomestic, setAvgShipmentLabelDomestic] = useState("Avg. Monthly Shipments");

    useEffect(() => {
        setAvgShipmentLabelDomestic(`Avg. ${selectedFrequency || "Monthly"} Shipments`);
    }, [selectedFrequency]);

    useEffect(() => {
        const cost    = parseFloat(estimatedBuyingRates) || 0;
        const rate    = parseFloat(freightRate)           || 0;
        const avgShip = parseFloat(avgMonthlyShipment)    || 0;

        const revenue = rate * avgShip;
        setTotalRevenue(revenue.toFixed(2));

        if (revenue > 0) {
            const gpr = ((revenue - cost) / revenue) * 100;
            setGrossProfitRate(gpr.toFixed(2));
        } else {
            setGrossProfitRate('');
        }
    }, [estimatedBuyingRates, freightRate, avgMonthlyShipment]);


    useEffect(() => {
        CrudService.getCompetitors()
            .then(resp => {
                const names = resp.data.map(item => item.attributes.competitorCompany)
                    .filter(Boolean);
                setCompetitorsList(names);
            })
            .catch(err => console.error(err));
    }, []);

    const handleExistingClick = () => {
        setCustomerType("existing");
        setShowButtons(false);
    };

    const handleProspectClick = () => {
        setShowButtons(false);
        navigate("/meeting/create-meeting/details");
    };

    const handleProspectGlobalAgentClick = () => {
        setShowButtons(false); // Butonları gizle
        navigate("/global-agent/create-global-agent/details");
    };

    useEffect(() => {
        if (isEditing) {
            setShowButtons(false);
        }
    }, [isEditing]);

    useEffect(() => {
        if (selectedCustomer) {
            setCustomerType("existing");
            setShowButtons(false);
        }
    }, [selectedCustomer]);


    useEffect(() => {
        if (isEditing) {
            if (!selectedCustomer) {
                setShowButtons(true);
            } else {
                setShowButtons(false);
            }
        }
    }, [isEditing, selectedCustomer]);

    const [strategies, setStrategies] = useState([]);
    const [selectedStrategies, setSelectedStrategies] = useState([]);
    const [selectedKeyMarkets, setSelectedKeyMarkets] = useState({});
    const [expanded, setExpanded] = useState([]);
    useEffect(() => {
        CrudService.getStrategies()
            .then(({ data }) => setStrategies(data.map(({ id, attributes }) => ({ id, ...attributes }))))
            .catch(console.error);
    }, []);
    const toStr = (x) => typeof x === "string" ? x : x?.label || x?.value || x?.code || x?.name || "";
    const sum = (arr) => arr.reduce((a, b) => a + b, 0);

    const toggleExpand = (id) => setExpanded((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
    const toggleSelectStrategy = (id) =>
        setSelectedStrategies((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
    const calcTotalScore = (s) => sum((s.keyMarkets || []).map((k) => Number(k.score || 0)));

    const toggleKM = (sId, kmId) => {
        if (!kmId) return;
        setSelectedKeyMarkets((prev) => {
            const cur = prev[sId] || [];
            const next = cur.includes(kmId)
                ? cur.filter((x) => x !== kmId)
                : [...cur, kmId];

            const updated = { ...prev, [sId]: next };
            if (next.length === 0) delete updated[sId];
            return updated;
        });
    };

    const mainRows = useMemo(() =>
        strategies.map((s) => {
            const km = s.keyMarkets || [];
            const exp = expanded.includes(s.id);
            const score = calcTotalScore(s);
            return {
                id: s.id,
                select: (
                    <Checkbox
                        checked={selectedStrategies.includes(s.id)}
                        onChange={() => toggleSelectStrategy(s.id)}
                    />
                ),
                details: km.length > 1 ? (
                    <IconButton size="small" onClick={() => toggleExpand(s.id)}>
                        {exp ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                ) : (
                    ""
                ),
                strategyName: (
                    <Link
                        to={`/strategy/create-strategy/details?id=${encodeURIComponent(s.id)}`}
                        style={{ textDecoration: "none", color: "#1976d2", fontWeight: 500 }}
                    >
                        {s.strategyName || "-"}
                    </Link>
                ),
                continent: km.map((k) => toStr(k.continent) || toStr(k.region)).filter(Boolean).join(", "),
                countries: km.flatMap((k) => (k.countries || []).map(toStr)).filter(Boolean).join(", "),
                score,
                incoterms: km.flatMap((k) => (k.selectedIncoterm || []).map(toStr)).filter(Boolean).join(", "),
                shippingPreferences: km.flatMap((k) => (k.shippingPreferences || []).map(toStr)).filter(Boolean).join(", "),
                industries: km.flatMap((k) => (k.industry || []).map(toStr)).filter(Boolean).join(", "),
                _km: km,
            };
        }), [strategies, selectedStrategies, expanded]);

    const rows = useMemo(() => {
        const out = [];
        mainRows.forEach((r) => {
            out.push(r);
            if (expanded.includes(r.id)) {
                r._km.forEach((km, idx) => {
                    const strategyId = r.id;
                    const kmId = km.id || km._id || `${strategyId}-${idx}`;

                    out.push({
                        id: `${strategyId}-km-${idx}`,
                        strategyId,
                        kmId,
                        select: null,
                        details: "",
                        strategyName: "",
                        continent: toStr(km.continent) || toStr(km.region) || "-",
                        countries: (km.countries || []).map(toStr).join(", ") || "-",
                        score: km.score || "-",
                        incoterms: (km.selectedIncoterm || []).map(toStr).join(", "),
                        shippingPreferences: (km.shippingPreferences || []).map(toStr).join(", "),
                        industries: (km.industry || []).map(toStr).join(", "),
                    });
                });

            }
        });
        return out;
    }, [mainRows, expanded, selectedKeyMarkets]);

    const table = useMemo(() => ({
        columns: [
            { Header: "Select", accessor: "select", width: "5%" },
            { Header: "#", accessor: "details", width: "5%" },
            { Header: "Strategy", accessor: "strategyName" },
            { Header: "Continents", accessor: "continent" },
            { Header: "Countries", accessor: "countries" },
            { Header: "Total Score", accessor: "score" },
            { Header: "Incoterms", accessor: "incoterms" },
            { Header: "Shipping Prefs", accessor: "shippingPreferences" },
            { Header: "Industries", accessor: "industries" },
        ],
        rows,
    }), [rows]);
    rows.forEach((row) => {
        if (row.strategyId && row.kmId) {
            row.select = (
                <Checkbox
                    checked={(selectedKeyMarkets[row.strategyId] || []).includes(row.kmId)}
                    onChange={() => toggleKM(row.strategyId, row.kmId)}
                />
            );
        }
    });

    return (
        <Grid container spacing={0} justifyContent="center" mb={1}>
            <Grid item xs={12} lg={10}>
                <MDBox mb={2}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox mb={1}>
                                <div ref={successMessageRef}>
                                    {successMessage && <CrmNotice sx={{ mb: 2 }}>{successMessage}</CrmNotice>}
                                </div>
                                <CrmPageHeader title={(isEditing
                                            ? " Edit ROAD & Intermodal Opportunity Details"
                                            : " Add ROAD & Intermodal Opportunity Details").trim()} subtitle="This information will give you more information about the Opportunity for ROAD & Intermodal." />
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox mt={3}
                        sx={{
                            ...crmCardSx,
                            overflow: "visible",
                            p: 3,
                        }}>                    <MDBox mb={3}>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDBox>
                                        <Grid container spacing={3} alignItems="center">
                                            <Grid item xs={6}>
                                                <MDTypography variant="h5" component="div">
                                                    General Opportunity Information
                                                </MDTypography>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <Grid container spacing={3} alignItems="center" mt={1}>
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={roadTransportType === "FTL"}
                                                        onChange={() => handleSwitchChangeTransportType("FTL")}
                                                        name="ftlSwitch"
                                                        sx={{
                                                            "& .MuiSwitch-thumb": {
                                                                backgroundColor: roadTransportType === "FTL" ? "orange" : "white",
                                                            },
                                                            "& .MuiSwitch-track": {
                                                                backgroundColor: roadTransportType === "FTL" ? "#FFECB3" : "#E0E0E0",
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="FTL"
                                                sx={{ color: "gray" }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={roadTransportType === "LTL"}
                                                        onChange={() => handleSwitchChangeTransportType("LTL")}
                                                        name="ltlSwitch"
                                                        sx={{
                                                            "& .MuiSwitch-thumb": {
                                                                backgroundColor: roadTransportType === "LTL" ? "orange" : "white",
                                                            },
                                                            "& .MuiSwitch-track": {
                                                                backgroundColor: roadTransportType === "LTL" ? "#FFECB3" : "#E0E0E0",
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="LTL"
                                                sx={{ color: "gray" }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={roadTransportType === "Domestic"}
                                                        onChange={() => handleSwitchChangeTransportType("Domestic")}
                                                        name="domesticSwitch"
                                                        sx={{
                                                            "& .MuiSwitch-thumb": {
                                                                backgroundColor: roadTransportType === "Domestic" ? "orange" : "white",
                                                            },
                                                            "& .MuiSwitch-track": {
                                                                backgroundColor: roadTransportType === "Domestic" ? "#FFECB3" : "#E0E0E0",
                                                            },
                                                        }}
                                                    />
                                                }
                                                label="Domestic"
                                                sx={{ color: "gray" }}
                                            />
                                        </Grid>
                                    </Grid>

                                    <MDBox mt={3}>
                                        <Grid container spacing={2} alignItems="flex-end">

                                            {/* Existing / Prospect Buttons + Customer Select */}
                                            <Grid item xs={12} sm={6}>
                                                {showButtons ? (
                                                    <MDBox mb={1} display="flex" gap={1}>
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: "#04c8e3",
                                                                color: "#fff",
                                                                height: 40,
                                                                textTransform: "none",
                                                                "&:hover": { backgroundColor: "#04c8e3" }
                                                            }}
                                                            onClick={handleExistingClick}
                                                        >
                                                            Existing Customer
                                                        </Button>

                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: "#ff7400",
                                                                color: "#fff",
                                                                height: 40,
                                                                textTransform: "none",
                                                                "&:hover": { backgroundColor: "#ff7400" }
                                                            }}
                                                            onClick={handleProspectClick}
                                                        >
                                                            Prospect Customer
                                                        </Button>

                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: "#061a9e",
                                                                color: "#fff",
                                                                height: 40,
                                                                textTransform: "none",
                                                                "&:hover": { backgroundColor: "#061a9e" }
                                                            }}
                                                            onClick={handleProspectGlobalAgentClick}
                                                        >
                                                            Prospect Global Agent
                                                        </Button>
                                                    </MDBox>
                                                ) : (
                                                    customerType === "existing" && (
                                                        <Autocomplete
                                                            value={selectedCustomer}
                                                            onChange={(event, newValue) => setSelectedCustomer(newValue)}
                                                            options={customerOptions}
                                                            getOptionLabel={(option) => option?.name || ""}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Customer"
                                                                    fullWidth
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{
                                                                        "& .MuiInputBase-root": { height: 40 },
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    )
                                                )}
                                            </Grid>

                                            {/* Customer Category */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={customerCategoryOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={
                                                        selectedCustomerCategory
                                                            ? { label: selectedCustomerCategory }
                                                            : null
                                                    }
                                                    onChange={(event, newValue) =>
                                                        setSelectedCustomerCategory(newValue ? newValue.label : "")
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Customer Category"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                "& .MuiInputBase-root": { height: 40 },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {/* Opportunity Name */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    label="Opportunity Name"
                                                    value={opportunityName}
                                                    onChange={(e) => setOpportunityName(e.target.value)}
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{
                                                        "& .MuiInputBase-root": { height: 40 },
                                                    }}
                                                />
                                            </Grid>

                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={3}>
                                        <Grid container spacing={2} alignItems="flex-end">

                                            {/* Transport Type */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    label="Transport Type"
                                                    value={selectedTransportType}
                                                    disabled
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{
                                                        "& .MuiInputBase-root": { height: 40 }
                                                    }}
                                                />
                                            </Grid>

                                            {/* Estimated Start Date */}
                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated Start Date"
                                                        value={estimatedStartDate}
                                                        onChange={(newValue) => setEstimatedStartDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                size: "small",
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: {
                                                                    "& .MuiInputBase-root": { height: 40 }
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            {/* Estimated End Date */}
                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated End Date"
                                                        value={estimatedEndDate}
                                                        onChange={(newValue) => setEstimatedEndDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                size: "small",
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: {
                                                                    "& .MuiInputBase-root": { height: 40 }
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            {/* Estimated Close Date */}
                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated Close Date"
                                                        value={estimatedCloseDate}
                                                        onChange={(newValue) => setEstimatedCloseDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                size: "small",
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: {
                                                                    "& .MuiInputBase-root": { height: 40 }
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            {/* Frequency Select */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={frequencyOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedFrequency ? { label: selectedFrequency } : null}
                                                    onChange={(event, newValue) =>
                                                        setSelectedFrequency(newValue ? newValue.label : "")
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Frequency"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                "& .MuiInputBase-root": { height: 40 }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={3}>
                                        <Grid container spacing={2}>
                                            {/* Business Status + Progress */}
                                            <Grid item xs={12} sm={3}>
                                                <Box>
                                                    <Autocomplete
                                                        options={statusOptions}
                                                        getOptionLabel={(opt) => opt.label}
                                                        value={selectedStatus ? { label: selectedStatus } : null}
                                                        onChange={(_, newVal) => setSelectedStatus(newVal ? newVal.label : "Prospect")}
                                                        isOptionEqualToValue={(opt, val) => opt.label === val.label}
                                                        disableClearable

                                                        // ✅ dropdown seçenekleri dot'lu
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li {...props} key={option.label}>
                                                              <span style={{ display: "flex", alignItems: "center" }}>
                                                                <StatusDot status={option.label} />
                                                                  {option.label}
                                                              </span>
                                                            </li>
                                                        )}

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Business Status"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        height: 40,
                                                                        alignItems: "center", // ✅ dikey ortalama
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    ...params.InputProps,

                                                                    // ✅ seçili değerde dot (tam ortada)
                                                                    startAdornment: selectedStatus ? (
                                                                        <>
                                                                            <InputAdornment position="start" sx={{ m: 0 }}>
                                                                                <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                                                                    <StatusDot status={selectedStatus} />
                                                                                </Box>
                                                                            </InputAdornment>

                                                                            {/* ✅ Autocomplete'ın kendi startAdornment'ını (chips vs) koru */}
                                                                            {params.InputProps.startAdornment}
                                                                        </>
                                                                    ) : (
                                                                        params.InputProps.startAdornment
                                                                    ),
                                                                }}
                                                            />
                                                        )}

                                                    />


                                                    <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                                                        <Box sx={{ flexGrow: 1 }}>
                                                            <ProgressBar barValue={barValue} color={color} />
                                                        </Box>
                                                        <Box sx={{ ml: 1, minWidth: 40 }}>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {labelValue}%
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Grid>

                                            {/* Lost Reason (conditional) */}
                                            {selectedStatus === "Lost" && (
                                                <Grid item xs={12} sm={9}>
                                                    <TextField
                                                        fullWidth
                                                        label="Lost Reason"
                                                        value={lostReason}
                                                        onChange={(e) => setLostReason(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            "& .MuiInputBase-root": { height: 40 },
                                                        }}
                                                    />
                                                </Grid>
                                            )}

                                            {/* Opportunity Owner */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesRep}
                                                    onChange={(_, newValues) => setSalesRep(newValues)}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Opportunity Owner"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {/* Sales Representatives */}
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesTeam}
                                                    onChange={(_, newValues) => setSalesTeam(newValues)}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Sales Representatives"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <Grid container spacing={3} alignItems="flex-start">

                                            {/* ---------------- PICKUP LOCATION ---------------- */}
                                            <Grid item xs={12} sm={6}>
                                                <MDTypography variant="h5">Pickup Location</MDTypography>
                                                <MDBox mt={2}>
                                                    <Grid container spacing={2} alignItems="center">

                                                        {/* Country */}
                                                        <Grid item xs={4}>
                                                            <Autocomplete
                                                                fullWidth
                                                                options={countryOptions}
                                                                getOptionLabel={(option) => option.label}
                                                                value={selectedPickupCountry}
                                                                onChange={(event, newValue) => {
                                                                    setSelectedPickupCountry(newValue);
                                                                    setPickupLocation(prev => ({
                                                                        ...prev,
                                                                        selectedPickupCountry: newValue ? newValue.label : ""
                                                                    }));
                                                                }}
                                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                                    <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <img src={option.flagUrl} width="24" height="16" />
                                                                        {option.label}
                                                                    </li>
                                                                )}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Pickup Country"
                                                                        fullWidth
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>

                                                        {/* City */}
                                                        <Grid item xs={4}>
                                                                <Autocomplete
                                                                    fullWidth
                                                                    options={pickupCityOptions}
                                                                    loading={pickupCityLoading}
                                                                    value={
                                                                        pickupLocation.pickupCity
                                                                            ? { label: pickupLocation.pickupCity, value: pickupLocation.pickupCity }
                                                                            : null
                                                                    }
                                                                    onChange={(_, newValue) => {
                                                                        setPickupLocation((p) => ({
                                                                            ...p,
                                                                            pickupCity: newValue?.value || "",
                                                                        }));
                                                                    }}
                                                                    // istersen kullanıcı manuel yazabilsin:
                                                                    freeSolo
                                                                    onInputChange={(_, val, reason) => {
                                                                        if (reason === "input") {
                                                                            setPickupLocation((p) => ({ ...p, pickupCity: val }));
                                                                        }
                                                                    }}
                                                                    getOptionLabel={(opt) => opt?.label || ""}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="City"
                                                                            fullWidth
                                                                            InputLabelProps={{ shrink: true }}
                                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                        />
                                                                    )}
                                                                />
                                                        </Grid>

                                                        {/* Additional Info */}
                                                        <Grid item xs={4}>
                                                            <TextField
                                                                fullWidth
                                                                type="text"
                                                                label="Additional Info"
                                                                value={pickupLocation.additionalInfo}
                                                                onChange={(e) => handleStateChange(setPickupLocation, "additionalInfo", e.target.value)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </MDBox>
                                            </Grid>

                                            {/* ---------------- DELIVERY LOCATION ---------------- */}
                                            <Grid item xs={12} sm={6}>
                                                <MDTypography variant="h5">Delivery Location</MDTypography>
                                                <MDBox mt={2}>
                                                    <Grid container spacing={2} alignItems="center">

                                                        {/* Country */}
                                                        <Grid item xs={4}>
                                                            <Autocomplete
                                                                fullWidth
                                                                options={countryOptions}
                                                                getOptionLabel={(option) => option.label}
                                                                value={selectedDeliveryCountry}
                                                                onChange={(event, newValue) => {
                                                                    setSelectedDeliveryCountry(newValue);
                                                                    setDeliveryLocation((prev) => ({
                                                                        ...prev,
                                                                        selectedDeliveryCountry: newValue ? newValue.label : "",
                                                                    }));
                                                                }}
                                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                                    <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <img src={option.flagUrl} width="24" height="16" />
                                                                        {option.label}
                                                                    </li>
                                                                )}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Delivery Country"
                                                                        fullWidth
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>

                                                        {/* City */}
                                                        <Grid item xs={4}>
                                                                <Autocomplete
                                                                    fullWidth
                                                                    options={deliveryCityOptions}
                                                                    loading={deliveryCityLoading}
                                                                    value={
                                                                        deliveryLocation.deliveryCity
                                                                            ? { label: deliveryLocation.deliveryCity, value: deliveryLocation.deliveryCity }
                                                                            : null
                                                                    }
                                                                    onChange={(_, newValue) => {
                                                                        setDeliveryLocation((p) => ({
                                                                            ...p,
                                                                            deliveryCity: newValue?.value || "",
                                                                        }));
                                                                    }}
                                                                    freeSolo
                                                                    onInputChange={(_, val, reason) => {
                                                                        if (reason === "input") {
                                                                            setDeliveryLocation((p) => ({ ...p, deliveryCity: val }));
                                                                        }
                                                                    }}
                                                                    getOptionLabel={(opt) => opt?.label || ""}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="City"
                                                                            fullWidth
                                                                            InputLabelProps={{ shrink: true }}
                                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                        />
                                                                    )}
                                                                />
                                                        </Grid>

                                                        {/* Additional Info */}
                                                        <Grid item xs={4}>
                                                            <TextField
                                                                fullWidth
                                                                type="text"
                                                                label="Additional Info"
                                                                value={deliveryLocation.additionalInfo}
                                                                onChange={(e) => handleStateChange(setDeliveryLocation, "additionalInfo", e.target.value)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </MDBox>
                                            </Grid>

                                        </Grid>

                                        {/* ----------------------- FTL & LTL PART ----------------------- */}
                                        {(roadTransportType === "FTL" || roadTransportType === "LTL") && (
                                            <>
                                                <MDBox mt={3}>
                                                    <Grid container spacing={2} alignItems="center">

                                                        {/* Truck Select */}
                                                        <Grid item xs={12} sm={3}>
                                                            <Autocomplete
                                                                fullWidth
                                                                options={truckType}
                                                                getOptionLabel={(option) => option.label}
                                                                value={selectedTransport}
                                                                onChange={(e, newValue) => setSelectedTransport(newValue)}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Select Truck"
                                                                        fullWidth
                                                                        InputLabelProps={{ shrink: true }}
                                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>

                                                        {/* Avg CBM only for LTL */}
                                                        {roadTransportType === "LTL" && (
                                                            <Grid item xs={12} sm={2}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Avg. CBM per Shipment"
                                                                    value={avgCBM}
                                                                    onChange={(e) => setAvgCBM(e.target.value)}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                />
                                                            </Grid>
                                                        )}

                                                    </Grid>
                                                </MDBox>

                                                {/* ---------------- FINANCIAL DATA ---------------- */}
                                                <MDTypography variant="h5" mt={4}>Financial & Commercial Data</MDTypography>

                                                <Grid container spacing={2} mt={1} alignItems="center">

                                                    {/* Avg Monthly Shipment */}
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            label={
                                                                roadTransportType === "FTL"
                                                                    ? `Avg. ${selectedFrequency || "Monthly"} FTL Shipments`
                                                                    : `Avg. ${selectedFrequency || "Monthly"} LTL Shipments`
                                                            }
                                                            value={avgMonthlyShipment}
                                                            onChange={(e) => setAvgMonthlyShipment(e.target.value)}
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                    {/* Freight Rate */}
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            label={
                                                                roadTransportType === "FTL"
                                                                    ? "Estimated Revenue per Truck"
                                                                    : "Estimated Revenue"
                                                            }
                                                            value={freightRate}
                                                            onChange={(e) => setFreightRate(e.target.value)}
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                    {/* Currency */}
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            label="Currency"
                                                            value={freightRateCurrency}
                                                            onChange={(e) => setFreightRateCurrency(e.target.value)}
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        >
                                                            <MenuItem value="USD">USD</MenuItem>
                                                            <MenuItem value="EUR">EUR</MenuItem>
                                                            <MenuItem value="TRY">TRY</MenuItem>
                                                            <MenuItem value="GBP">GBP</MenuItem>
                                                        </TextField>
                                                    </Grid>

                                                    {/* Total Revenue */}
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            fullWidth
                                                            label="Total Gross Revenue"
                                                            value={totalRevenue}
                                                            disabled
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </>
                                        )}

                                        {/* ---------------------------------------------------- */}
                                        {/* ---------------- DOMESTIC BLOCKS ------------------- */}
                                        {/* ---------------------------------------------------- */}

                                        {roadTransportType === "Domestic" && (
                                            <>
                                                <MDTypography variant="h5" mt={4}>Financial & Commercial Data</MDTypography>

                                                {domesticBlocks.map((block, index) => (
                                                    <MDBox key={index} mt={3} p={2} sx={{ border: "1px solid #ddd", borderRadius: 2 }}>
                                                        <Grid container spacing={2} alignItems="center">

                                                            {/* Container */}
                                                            <Grid item xs={12} sm={2}>
                                                                <Autocomplete
                                                                    options={containerOptions}
                                                                    getOptionLabel={(opt) => opt.label}
                                                                    value={block.selectedContainer}
                                                                    onChange={(_, newVal) => updateDomesticBlock(index, "selectedContainer", newVal)}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Select Container"
                                                                            fullWidth
                                                                            InputLabelProps={{ shrink: true }}
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>

                                                            {/* Avg Monthly Shipments */}
                                                            <Grid item xs={12} sm={2}>
                                                                <TextField
                                                                    fullWidth
                                                                    label={avgMonthlyShipmentLabelDomestic}
                                                                    value={block.avgMonthlyShipment}
                                                                    onChange={(e) => updateDomesticBlock(index, "avgMonthlyShipment", e.target.value)}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                />
                                                            </Grid>

                                                            {/* Freight Rate */}
                                                            <Grid item xs={12} sm={2}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Estimated Revenue per Truck"
                                                                    value={block.freightRate}
                                                                    onChange={(e) => updateDomesticBlock(index, "freightRate", e.target.value)}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                />
                                                            </Grid>

                                                            {/* Currency */}
                                                            <Grid item xs={12} sm={1}>
                                                                <TextField
                                                                    select
                                                                    fullWidth
                                                                    label="Currency"
                                                                    value={block.currency}
                                                                    onChange={(e) => updateDomesticBlock(index, "currency", e.target.value)}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                >
                                                                    <MenuItem value="USD">USD</MenuItem>
                                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                                    <MenuItem value="TRY">TRY</MenuItem>
                                                                    <MenuItem value="GBP">GBP</MenuItem>
                                                                </TextField>
                                                            </Grid>

                                                            {/* Total Revenue */}
                                                            <Grid item xs={12} sm={1}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Total Revenue"
                                                                    disabled
                                                                    value={block.totalRevenue?.toFixed(2)}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </MDBox>
                                                ))}

                                                {/* Add / Remove Buttons */}
                                                <Grid container spacing={2} mt={2} justifyContent="flex-end">
                                                    <Grid item>
                                                        <AddRowButton onClick={addNewDomesticBlock} tooltip="Add route" />
                                                    </Grid>
                                                    {domesticBlocks.length > 1 && (
                                                        <Grid item>
                                                            <RemoveRowButton onClick={() => removeDomesticBlock(domesticBlocks.length - 1)} tooltip="Remove route" />
                                                        </Grid>
                                                    )}
                                                </Grid>

                                                {/* Summary */}
                                                <MDBox mt={3}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} sm={4}>
                                                            <TextField
                                                                fullWidth
                                                                label="Total Gross Revenue (Sum)"
                                                                disabled
                                                                value={`${totalRevenueSum.toFixed(2)} ${domesticBlocks[0]?.currency || ""}`}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        </Grid>

                                                        {domesticBlocks[0]?.grossProfitType === "perTruck" && (
                                                            <Grid item xs={12} sm={4}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Total Per Truck Gross Profit"
                                                                    disabled
                                                                    value={`${totalPerTruckProfitSum.toFixed(2)} ${domesticBlocks[0]?.currency || ""}`}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </MDBox>
                                            </>
                                        )}
                                    </MDBox>
                                    <Grid container spacing={3} mt={3} alignItems="center">

                                        {/* Payment Terms */}
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                label="Payment Terms"
                                                value={paymentTerms}
                                                onChange={(e) => setPaymentTerms(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{
                                                    "& .MuiInputBase-root": { height: 40 }
                                                }}
                                            />
                                        </Grid>

                                        {/* Payment Performance */}
                                        <Grid item xs={12} sm={4}>
                                            <Autocomplete
                                                fullWidth
                                                options={paymentPerformanceOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedPaymentPerformance ? { label: selectedPaymentPerformance } : null}
                                                onChange={(event, newValue) =>
                                                    setSelectedPaymentPerformance(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(option, value) => option.label === value.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        label="Payment Performance"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            "& .MuiInputBase-root": { height: 40 }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Operational Challenges */}
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                label="Operational Challenges"
                                                value={operationalChallenges}
                                                onChange={(e) => setOperationalChallenges(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{
                                                    "& .MuiInputBase-root": { height: 40 }
                                                }}
                                            />
                                        </Grid>

                                    </Grid>
                                    <br/>
                                    <MDTypography mt={3} variant="h5">Competitor Analysis</MDTypography>
                                    <Grid container spacing={3} mt={1} alignItems="center">

                                        {/* Freight Forwarders */}
                                        <Grid item xs={12} sm={4}>
                                            <Autocomplete
                                                fullWidth
                                                options={forwarderOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedForwarder ? { label: selectedForwarder } : null}
                                                onChange={(event, newValue) =>
                                                    setSelectedForwarder(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(option, value) => option.label === value.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Freight Forwarders"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            "& .MuiInputBase-root": { height: 40 }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Competing Freight Forwarders */}
                                        <Grid item xs={12} sm={4}>
                                            <Autocomplete
                                                fullWidth
                                                freeSolo
                                                options={competitorsList}
                                                value={competingFreightForwarders}
                                                onInputChange={(_, newValue) => setCompetingFreightForwarders(newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Competing Freight Forwarders"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            "& .MuiInputBase-root": { height: 40 }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Competing Transport Companies */}
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                label="Competing Transport Companies"
                                                value={competingTransportCompanies}
                                                onChange={(e) => setCompetingTransportCompanies(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{
                                                    "& .MuiInputBase-root": { height: 40 }
                                                }}
                                            />
                                        </Grid>

                                    </Grid>

                                    <Grid container spacing={3} mt={3} alignItems="center">

                                        {/* Price Comparison */}
                                        <Grid item xs={12} sm={4}>
                                            <Autocomplete
                                                fullWidth
                                                options={priceComparisonOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedPriceComparison ? { label: selectedPriceComparison } : null}
                                                onChange={(event, newValue) =>
                                                    setSelectedPriceComparison(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(option, value) => option.label === value.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Price Comparison"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            "& .MuiInputBase-root": { height: 40 }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Customer Loyalty to Competitor */}
                                        <Grid item xs={12} sm={4}>
                                            <Autocomplete
                                                fullWidth
                                                options={loyaltyOptions}
                                                getOptionLabel={(option) => option.label}
                                                value={selectedLoyalty ? { label: selectedLoyalty } : null}
                                                onChange={(event, newValue) =>
                                                    setSelectedLoyalty(newValue ? newValue.label : "")
                                                }
                                                isOptionEqualToValue={(option, value) => option.label === value.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Customer Loyalty to Competitor"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{
                                                            "& .MuiInputBase-root": { height: 40 }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                    </Grid>

                                    <MDTypography mt={3} variant="h5">Customer Follow-up & Management</MDTypography>

                                    <Grid container spacing={3} mt={1} alignItems="center">

                                        {/* Last Follow-up Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Last Follow-up Date"
                                                    value={lastFollowupDate}
                                                    onChange={(newValue) => setLastFollowupDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            fullWidth: true,
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": { height: 29 }
                                                            }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Next Follow-up Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Next Follow-up Date"
                                                    value={nextFollowupDate}
                                                    onChange={(newValue) => setNextFollowupDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            fullWidth: true,
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": { height: 29 }
                                                            }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Last Meeting Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Last Meeting Date"
                                                    value={lastMeetingDate}
                                                    onChange={(newValue) => setLastMeetingDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            fullWidth: true,
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": { height: 29 }
                                                            }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        {/* Next Scheduled Meeting Date */}
                                        <Grid item xs={12} sm={3}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                <DatePicker
                                                    label="Next Scheduled Meeting Date"
                                                    value={nextMeetingDate}
                                                    onChange={(newValue) => setNextMeetingDate(newValue)}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "standard",
                                                            size: "small",
                                                            fullWidth: true,
                                                            sx: {
                                                                minWidth: 200,
                                                                "& .MuiInputBase-root": { height: 29 }
                                                            }
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                    </Grid>

                                    <Grid container spacing={3} mt={5}>
                                        <Grid item xs={12}>
                                            <TextField
                                                type="text"
                                                label="Notes & Special Considerations"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                multiline
                                                minRows={3}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{
                                                    "& .MuiInputBase-root": { minHeight: 40 }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <br/>

                                </MDBox>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} mt={8}>
                            <MDTypography variant="h6" mb={2}>
                                STRATEGIES
                            </MDTypography>
                            <MDBox p={2} boxShadow={1} bgcolor="#fafafa" borderRadius={2}>
                                <DataTable table={table}/>
                            </MDBox>
                        </Grid>
                    </MDBox>

                    <MDBox mt={5}>
                        <Grid container spacing={2} justifyContent="flex-start">
                            {/* Create Meeting Butonu - Sadece Meetings Sayfasından Gelmeyenler İçin */}
                            {!isFromMeetings && (
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => navigate("/meeting/create-meeting/details")}
                                        sx={{
                                            backgroundColor: "#FFFFFF",
                                            color: "#101828 !important",
                                            border: "1px solid rgba(15, 23, 42, 0.12)",
                                            padding: "10px 20px",
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            fontWeight: 600,
                                            boxShadow: "none",
                                            "&:hover": { backgroundColor: "#FFFFFF", borderColor: "#175CD3", color: "#175CD3 !important", boxShadow: "none" },
                                        }}
                                    >
                                        Create Meeting
                                    </Button>
                                </Grid>
                            )}

                            {/* Create / Update Opportunity Butonu */}
                            <Grid item>
                                <form onSubmit={submitHandler}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        sx={{
                                            backgroundColor: "#0B1F3A",
                                            color: "#FFFFFF !important",
                                            padding: "10px 20px",
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            fontWeight: 600,
                                            boxShadow: "none",
                                            "&:hover": { backgroundColor: "#12345B", boxShadow: "none" },
                                        }}
                                    >
                                        {isEditing ? "Update Opportunity" : "Create Opportunity"}
                                    </Button>
                                </form>
                            </Grid>
                        </Grid>
                    </MDBox>

                </MDBox>
            </Grid>
        </Grid>
    );
};

export default RoadForm;
